import React from 'react';

interface Props extends React.SVGAttributes<SVGSVGElement> {
  color?: string;
}

export default function Check1({ color = 'white', width = 24, height = 24, ...rest }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0136 4.89428C21.6243 5.45407 21.6655 6.40292 21.1057 7.0136L10.1057 19.0136C9.82927 19.3152 9.44162 19.4908 9.03259 19.4997C8.62355 19.5085 8.22864 19.35 7.93934 19.0607L2.93934 14.0607C2.35355 13.4749 2.35355 12.5251 2.93934 11.9393C3.52513 11.3536 4.47487 11.3536 5.06066 11.9393L8.95288 15.8316L18.8943 4.98642C19.4541 4.37574 20.4029 4.33449 21.0136 4.89428Z"
        fill={color}
      />
    </svg>
  );
}
